import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { registerSW } from 'virtual:pwa-register'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

// Создаём уведомление об обновлении
function showUpdateNotification() {
  const notification = document.createElement('div')
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 16px 24px;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(0,0,0,0.3);
    z-index: 9999;
    font-size: 15px;
    font-weight: 600;
    animation: slideDown 0.3s ease-out;
  `
  notification.innerHTML = '🔄 Обновление приложения... Подождите 2 секунды'
  document.body.appendChild(notification)
  
  // Удаляем через 2 секунды
  setTimeout(() => {
    notification.remove()
  }, 2000)
}

// Регистрация Service Worker с автообновлением (через vite-plugin-pwa)
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    console.log('🔄 Доступна новая версия приложения')
    
    // Показываем уведомление
    showUpdateNotification()
    
    // Автоматически обновляем НЕМЕДЛЕННО
    updateSW(true)
  },
  onOfflineReady() {
    console.log('✅ Приложение готово к работе офлайн')
  },
  onRegistered(registration: ServiceWorkerRegistration | undefined) {
    console.log('✅ Service Worker зарегистрирован')
    
    // СРАЗУ проверяем обновления при открытии
    if (registration) {
      console.log('🔍 Немедленная проверка обновлений...')
      registration.update().catch(err => console.error('Ошибка проверки обновлений:', err))
      
      // И проверяем каждые 10 секунд (очень агрессивно для разработки)
      setInterval(() => {
        console.log('🔍 Автоматическая проверка обновлений...')
        registration.update().catch(err => console.error('Ошибка проверки обновлений:', err))
      }, 10000)
    }
  },
  onRegisterError(error: Error) {
    console.error('❌ Ошибка регистрации Service Worker:', error)
  },
})

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

